import { Helmet } from "react-helmet-async";

const Meta = ({title, description, keywords, image, url, jsonLd}) => {
  return (
    <Helmet>
      {/* Standard SEO */}
      <title>{title}</title>
      <meta name="description" content={description}/>
      <meta name="keywords" content={keywords}/>

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  )
}

Meta.defaultProps = {
  title: "Flavchap Telugu Snacks & Sweets",
  description: "We are committed to delivering fresh, tasty, traditional, high-quality home made telugu snacks and sweets. We take pride in curating regional specialties with authenticity and care. Whether you're shopping for a festive occasion or a daily craving, we're here to serve you with excellence.",
  keywords: "snacks, sweets, homemade, home made, telugu, telangana, andhra, pindi vantalu, telangana pindi vantalu, andhra pindi vantalu, home foods, swagruha foods, swagruha, food ecommerce, portal, website, hyderabad, home delivery, deliver to home, food delivery, home made foods, home made snacks, home made sweets, home made snacks and sweets",
  image: "https://www.flavchap.com/favicon.ico",
  url: "https://www.flavchap.com",
  jsonLd: null
}

export default Meta;